import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';

import {
  CmsImage,
  CmsUrl,
  CtaStyle,
  NavColumn,
} from '@digital-platform/rs-cms/domain';
import {
  CtaButtonComponent,
  InlineImageComponent,
  RichTextLinkComponent,
} from '@digital-platform/rs-cms/feature-ptypes';

@Component({
  selector: 'digital-platform-inline-image-nav',
  templateUrl: './inline-image-nav.component.html',
  styleUrls: ['./inline-image-nav.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    RichTextLinkComponent,
    InlineImageComponent,
    CtaButtonComponent,
  ],
})
export class InlineImageNavComponent {
  @Input() config: NavColumn = {
    link_a_target: undefined,
    link_title: null,
    mobile_title: null,
    link_url: '',
    link_description: null,
    link_icon: null,
    link_image_details: {
      target_id: null,
      alt: '',
      title: '',
      width: null,
      height: null,
    },
    link_image_overlay: null,
    link_image_style: null,
    link_image_url: null,
    link_style: [],
    logged_in: null,
  };

  public imageCtaLinkStyle: CtaStyle = {
    tid: 6201,
    name: 'White',
    ctaStyle: 'text-white',
  };
  public emptyImageLinkUrl: CmsUrl = [
    {
      uri: '',
      title: '',
      options: {
        attributes: {
          target: 0,
        },
      },
    },
  ];

  get webpMedia(): CmsImage {
    return {
      title: this.config.link_image_details?.title,
      src: this.config.link_image_url,
      alt: this.config.link_image_details?.alt,
      target_id: Number(this.config.link_image_details?.target_id),
      image_use: 'desktop',
      width: Number(this.config.link_image_details?.width),
      height: Number(this.config.link_image_details?.height),
    };
  }

  get url() {
    if (this.config.link_url && this.config.link_title) {
      return [
        {
          uri: this.config.link_url,
          title: this.config.link_title,
          options: {
            visibilityClass: {},
            attributes: { target: 0, class: '', rel: '' },
          },
        },
      ];
    }
    return [];
  }

  get linkStyles() {
    return this.config.link_style
      ? [...this.config.link_style, 'text-decoration-none']
      : ['text-decoration-none'];
  }

  getImageCtaLinkUrl(url = ''): CmsUrl {
    const retval = this.emptyImageLinkUrl;
    retval[0].uri = url;

    return retval;
  }
}
